import { render, staticRenderFns } from "./footerBotton.vue?vue&type=template&id=318875a8&scoped=true&"
import script from "./footerBotton.vue?vue&type=script&lang=js&"
export * from "./footerBotton.vue?vue&type=script&lang=js&"
import style0 from "./footerBotton.vue?vue&type=style&index=0&id=318875a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318875a8",
  null
  
)

export default component.exports